<script setup lang="ts">
    import CpText from '~/components/cp/CpText/CpText.vue';
    import useCpBem from '~/composables/useCpBem';
    import CpNuxtLink from '~/components/cp/CpNuxtLink/CpNuxtLink.vue';

    defineProps<{
      image: string,
      name: string,
      link: string
    }>();

    const {b, e} = useCpBem('cp-nav-menu-promo');
</script>

<template>
    <CpNuxtLink page-name="catalog" :link="link">
        <div :class="b">
            <v-img :src="image"
                width="140"
                height="48"
                :class="e('img')"
                :alt="name"
            />
            <CpText variant="body-regular" type="primary" :class="e('txt')">
                {{ name }}
            </CpText>
        </div>
    </CpNuxtLink>
</template>

<style scoped lang="scss">
  .cp-nav-menu-promo {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: $cp-gutter $cp-gutter-small ;
    border: $cp-border-standard;
    border-radius: $cp-border-radius;
    width: 158px;
    height: 106px;
    cursor: pointer;
    &__txt{
      margin-top: $cp-gutter-small;
    }
  }
</style>
